module.exports = __webpack_public_path__ + "static/img/culture2.33bf8d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture2.png
// module id = j5WH
// module chunks = 2